import React from "react";

function TestStageIcon() {
  return (
    <svg width="45" height="18" viewBox="0 0 45 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.916 13H11.912V5.884H14.456V4.996H8.384V5.884H10.916V13ZM16.1798 13H21.4238V12.112H17.1758V9.352H21.3398V8.464H17.1758V5.884H21.4238V4.996H16.1798V13ZM22.9318 11.872C23.5918 12.616 24.6118 13.144 26.0038 13.144C28.1638 13.144 28.9558 11.956 28.9558 10.792C28.9558 9.112 27.4678 8.704 26.1598 8.356C25.1398 8.08 24.2158 7.84 24.2158 7.036C24.2158 6.28 24.8998 5.764 25.8598 5.764C26.7358 5.764 27.5758 6.064 28.1758 6.724L28.7758 5.992C28.1038 5.284 27.1558 4.876 25.9318 4.876C24.3598 4.876 23.1838 5.776 23.1838 7.096C23.1838 8.668 24.6118 9.028 25.8958 9.364C26.9518 9.652 27.9238 9.916 27.9238 10.876C27.9238 11.488 27.4678 12.256 26.0398 12.256C24.9118 12.256 24.0478 11.704 23.5198 11.116L22.9318 11.872ZM32.7527 13H33.7487V5.884H36.2927V4.996H30.2207V5.884H32.7527V13Z"
        fill="#E3000F"
      />
      <rect x="0.5" y="0.5" width="44" height="17" rx="3.5" stroke="#E3000F" />
    </svg>
  );
}

export default TestStageIcon;
